import { escapeMarkdownLinkText } from '#pplx/frontend/common/markdownTitle.js';
export function escapeMarkdownLinkTitle(title) {
    return title.replace(/[\\()"]/g, (char) => `\\${char}`);
}
export function unescapeMarkdownLinkTitle(title) {
    return title.replace(/\\([\\()"])/g, '$1');
}
export function getMentionLinkMarkdown(text, url, title) {
    if (!url) {
        return null;
    }
    const linkText = escapeMarkdownLinkText(text || url);
    return title
        ? `[${linkText}](${url} "${escapeMarkdownLinkTitle(title)}")`
        : `[${linkText}](${url})`;
}
//# sourceMappingURL=getMentionLinkMarkdown.js.map